import { ApolloProvider } from '@apollo/client';
import React, { useEffect } from 'react';
import shortid from 'shortid';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { apolloClient } from '../apollo';
import { SESSION_TOKEN } from '../config';
import { CatalogCategoryView } from '../views/catalogCategory';
import { CatalogListView } from '../views/catalogList';
import './style.scss';
import { persistor, store } from '../data';
import { PersistGate } from 'redux-persist/integration/react';
import { Maintenance } from '../views/maintenance';

export const RootApp = () => {
  useEffect(() => {
    const t = localStorage.getItem(SESSION_TOKEN);
    if (!t) {
      localStorage.setItem(SESSION_TOKEN, shortid());
    }
  }, []);

  const MAINTENANCE = true;

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={apolloClient}>
          <Router>
            <div className="app-root">
              {MAINTENANCE ? (
                <Maintenance />
              ) : (
                <Switch>
                  <Route
                    path="/catalog/:catalogKey"
                    render={({ match }) => (
                      <CatalogCategoryView catalog={match.params.catalogKey} />
                    )}
                  />
                  <Route path="/catalog" component={CatalogListView} />
                  <Redirect to="/catalog" />
                </Switch>
              )}
            </div>
          </Router>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  );
};
